import * as React from 'react';

interface IGifConfing {
  name: string;
  src: string;
}

export type VALID_GIFS =
  | 'horizontal-id-back'
  | 'tutorial-dl-back'
  | 'tutorial-dl-front'
  | 'tutorial-passport'
  | 'tutorial-selfie';

const GIF_INFO: IGifConfing[] = [
  { name: 'horizontal-id-back', src: 'dec-horizontal-id-back.gif'},
  { name: 'tutorial-dl-back', src: 'dec-tutorial-dl-back.gif'},
  { name: 'tutorial-dl-front', src: 'dec-tutorial-dl-front.gif'},
  { name: 'tutorial-passport', src:  'dec-tutorial-passport.gif'},
  { name: 'tutorial-selfie', src: 'dec-tutorial-selfie.gif'}
];

interface ISourceInfo {
  src: string;
}

const requireDec: (gif: string) => string = gif =>
  // tslint:disable-next-line non-literal-require
  require(`../../../src/images/dec/${gif}`);

export const GIF_INFO_MAP: Map<VALID_GIFS, ISourceInfo> = new Map<
  VALID_GIFS,
  ISourceInfo
>(
  GIF_INFO.map(
    ({ name, src }) =>
      [name, { src: requireDec(src) }] as [
        VALID_GIFS,
        ISourceInfo
      ]
  )
);

export interface IGifProps {
  gif: VALID_GIFS;
}

export default class Gif extends React.PureComponent<
  React.ImgHTMLAttributes<HTMLImageElement> & IGifProps
> {
  public render () {
    const { gif, ...props } = this.props;

    const gifProps: ISourceInfo | undefined = GIF_INFO_MAP.get(gif);
    if (!gifProps) { throw new Error('Image Missing'); }

    return <img aria-hidden={true} {...props} {...gifProps} />;
  }
}
